import { createStore, applyMiddleware, Dispatch } from "redux";
import thunkMiddleware from "redux-thunk";
import { rootReducer } from "./reducers/rootReducer";
import { composeWithDevTools } from "redux-devtools-extension";
import { loadItem, saveItem } from "../utils/Store";
import jwt from "./../jwt";

const persistedState = loadItem("state");
export const store = createStore(
  rootReducer,
  persistedState || {},
  composeWithDevTools(applyMiddleware(thunkMiddleware, jwt))
);

store.subscribe(() => {
  const state = store.getState();
  saveItem("state", {
    auth: {
      token: state.auth.token,
      user: state.auth.user,
      sessionExpire: state.auth.sessionExpire,
      country: state.auth.country,
      buildings: state.auth.buildings,
      companies: state.auth.companies,
      loading: state.auth.loading,
      isAuthenticated: state.auth.isAuthenticated,
      residents: state.auth.residents,
      lots: state.auth.lots,
      professionTypes: state.auth.professionTypes,
      vehicleTypes: state.auth.vehicleTypes,
      allowTransport: state.auth.allowTransport,
      space: state.auth.space,
      lang: state.auth.lang,
      token_file: state.auth.token_file,
    },
  });
});